import type { HpSvgIconTypes } from '@avantia/style-guide';
import { HpAlert } from 'components/shared/alert';

import './loginError.scss';
import { ExternalLink } from 'components/shared/externalLink';
import { EXTERNAL_PATH } from 'interfaces/pathTypes';

interface LoginErrorProps {
  error?: string;
}

interface LoginErrrorContent {
  message: JSX.Element;
  header?: string;
}

export const LoginError = ({ error }: LoginErrorProps) => {
  const getUserMessage = (error?: string): LoginErrrorContent => {
    if (!error) {
      return {
        message: <p className="error-text">We are having trouble connecting to our server. Please try again later.</p>
      };
    }

    if (error.includes('No policies or quotes found for user')) {
      return {
        message: (
          <p className="error-text">
            Sorry, the details you provided cannot be found. Please try again or{' '}
            <ExternalLink href={EXTERNAL_PATH.CONTACT_US} id="contact-us">
              get in contact with us here
            </ExternalLink>
          </p>
        )
      };
    }

    if (error.includes('Invalid or expired token') || error.includes('token has reached its maximum number of uses')) {
      return {
        header: 'Sorry, this link is no longer valid.',
        message: <p className="error-text">Please request a new secure link, by entering your details below.</p>
      };
    }

    return {
      message: <p className="error-text">We are having trouble connecting to our server. Please try again later.</p>
    };
  };

  const { message, header } = getUserMessage(error);

  return (
    <HpAlert
      message={message}
      iconType={'exclamation' as HpSvgIconTypes}
      alertLevel="error"
      className="login-error-alert"
      header={header}
    />
  );
};
